import { render } from "./AddSpecial.vue?vue&type=template&id=0768056b&scoped=true"
import script from "./AddSpecial.vue?vue&type=script&lang=js"
export * from "./AddSpecial.vue?vue&type=script&lang=js"

import "./AddSpecial.vue?vue&type=style&index=0&id=0768056b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0768056b"

export default script